import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import DOMPurify from "dompurify";
import { FETCH_DATA_ESTATE_SUMMARY } from "../../DataTagConstants";
import "./DataEstateSummary.scss";

function DataEstateSummary() {
  const dispatch = useDispatch();

  const summaryData = useSelector(
    (state) => state.dataTagReducer.dataEstateSummary,
  );

  const dataSourceId = useSelector(
    (state) => state.dataTagReducer.selectedDataSource?.id,
  );

  useEffect(() => {
    if (dataSourceId) {
      dispatch({
        type: FETCH_DATA_ESTATE_SUMMARY,
        payload: { dataSourceId },
      });
    }
  }, [dataSourceId]);

  const highlightWords = [
    "highly",
    "high",
    "risk",
    "medium",
    "sensitivity",
    "sensitive",
    "publicly",
    "low",
    "public",
    "PCI_DSS",
    "PII",
    "GDPR",
    "Confidential",
    "Financial",
    "PHI/HIPAA",
    "Regulated",
  ];

  const processedHTML = useMemo(() => {
    const raw = typeof summaryData?.text === "string" ? summaryData.text : "-";

    let updated = raw;

    highlightWords.forEach((word) => {
      const regex = new RegExp(`(${word})`, "gi");
      updated = updated.replace(regex, "<b>$1</b>");
    });

    updated = updated.replace(/\n/g, "<br />");

    return DOMPurify.sanitize(updated);
  }, [summaryData, highlightWords]);

  return (
    <div className="de-summary-container">
      <div className="de-summary-card">
        <p
          className="de-summary-text"
          dangerouslySetInnerHTML={{ __html: processedHTML }}
        />
      </div>
    </div>
  );
}

export default DataEstateSummary;